





















import { mapMutations } from 'vuex'

export default {
  name: 'ReleaseBanner',
  data() {
    return {
      isOpen: true
    }
  },
  mounted() {
    const shouldBeOpen = !localStorage.getItem('releaseBannerClosed')
    this.isOpen = !!shouldBeOpen
    this.setIsBannerOpen(this.isOpen)
  },
  methods: {
    ...mapMutations(['setIsBannerOpen']),
    closeBanner() {
      localStorage.setItem('releaseBannerClosed', 'true')
      this.isOpen = false
      this.setIsBannerOpen(false)
    }
  }
}
